export const Distribute = {
  two: [50, 50],
  three: [34, 33, 33],
  four: [25, 25, 25, 25]
};
